// extracted by mini-css-extract-plugin
module.exports = {"time":"CurrentTime_time__Zb4Kf","time__title":"CurrentTime_time__title__YMzb2"};